module.exports = {
      id: "russia-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#russia-usage",
      toString: function () {
        return this.url;
      }
    }